import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/Login/LogIn.vue'
import Logout from '@/components/Login/LogOut.vue'
import Maintenance from '@/components/Maintenance/Maintenance.vue'
import general from '@/store/modules/general.js'

Vue.use(VueRouter)

const GROUPS = general.GROUPS
const ERP_GROUPS = general.ERP_GROUPS

let defaultAccesAllowedRoles = [
  'SuperAdmin',
  'Admin',
  'Manager',
  'Comercial'
]

const routes = [
  {
    path: '/',
    name: null,
    props: true,
    meta: {
      accessAllowedGroups: ERP_GROUPS,
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true,
    meta: {
      accessAllowedGroups: [],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    props: true,
    meta: {
      accessAllowedGroups: [],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/mfa/setup',
    name: 'mfaSetup',
    // component: MfaSetup,
    component: () => import(/* webpackChunkName: "mfaSetup" */
      '../components/MFA/MfaSetup.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/teletrabajo',
    name: 'teletrabajo',

    component: () => import(/* webpackChunkName: "teletrabajo" */
      '../components/ComercialTeletrabajo/ComercialTeletrabajo.vue'),
    props: true,
    meta: {
      accessAllowedGroups: ERP_GROUPS,
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/retailX',
    name: 'retailX',
    component: () => import(/* webpackChunkName: "retailX" */
      '../components/RetailX/RetailX.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [GROUPS.VODAFONE],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/gerencia',
    name: 'gerencia',
    component: () => import(/* webpackChunkName: "gerencia" */
      '../components/GerenciaTeletrabajo/GerenciaTeletrabajo.vue'),
    redirect: { name: 'comerciales' },
    props: true,
    meta: {
      accessAllowedGroups: ERP_GROUPS,
      accessAllowedRoles: [
        'SuperAdmin',
        'Admin',
        'Manager',
      ]
    },
    children: [
      {
        path: 'comerciales',
        name: 'comerciales',
        component: () => import('../components/GerenciaTeletrabajo/ComercialesTable/ComercialesTable.vue'),
        meta: {
          accessAllowedGroups: ERP_GROUPS,
          accessAllowedRoles: defaultAccesAllowedRoles
        }
      },
      {
        path: 'proyeccion',
        name: 'proyeccion',
        component: () => import('../components/GerenciaTeletrabajo/ObjectivesReport/ObjectivesReportBase.vue'),
        meta: {
          accessAllowedGroups: ERP_GROUPS,
          accessAllowedRoles: defaultAccesAllowedRoles
        }
      },
      {
        path: 'reporte',
        name: 'reporte',
        component: () => import('../components/GerenciaTeletrabajo/ReportTable/ReportTable.vue'),
        meta: {
          accessAllowedGroups: ERP_GROUPS,
          accessAllowedRoles: defaultAccesAllowedRoles
        }
      },
      {
        path: 'estadisticas',
        name: 'estadisticas',
        component: () => import('../components/GerenciaTeletrabajo/Stats/Stats.vue'),
        meta: {
          accessAllowedGroups: ERP_GROUPS,
          accessAllowedRoles: defaultAccesAllowedRoles
        }
      },
    ]
  },
  {
    path: '/rrhh',
    name: 'rrhh',

    component: () => import(/* webpackChunkName: "rrhh" */
      '../components/RRHH/RRHH.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [],
      accessAllowedRoles: [
        'SuperAdmin',
        'Admin',
      ]
    }
  },
  {
    path: '/offerconfigurator/:id',
    name: 'OfferConfigurator',
    component: () => import(/* webpackChunkName: "OfferConfigurator" */
      '../components/ComercialTeletrabajo/OfferConfigurator/BaseConfigurator.vue'),
    props: true,
    meta: {
      accessAllowedGroups: ERP_GROUPS,
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/devicemanagement',
    name: 'devicemanagement',

    component: () => import(/* webpackChunkName: "devicemanagement" */
      '../components/ComercialTeletrabajo/DeviceManagement/DeviceManagementTable.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [GROUPS.MASMOVIL],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/dashBoard',
    name: 'dashboard',

    component: () => import(/* webpackChunkName: "dashBoard" */
      '../components/DashBoard/DashBoardBase.vue'),
    props: true,
    meta: {
      accessAllowedGroups: ERP_GROUPS,
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/ManagementBase',
    name: 'managementBase',

    component: () => import(/* webpackChunkName: "ManagementBase" */
      '../components/GerenciaTeletrabajo/Management/ManagementBase.vue'),
    props: true,
    meta: {
      accessAllowedGroups: ERP_GROUPS,
      accessAllowedRoles: [
        'SuperAdmin',
        'Admin',
        'Manager',
      ]
    }
  },
  {
    path: '/areapersonal',
    name: 'areaPersonal',
    component: () => import(/* webpackChunkName: "detail" */
      '../components/AreaPersonal/AreaPersonal.vue'),
    redirect: { name: 'calculadora' },
    props: true,
    meta: {
      accessAllowedGroups: ERP_GROUPS,
      accessAllowedRoles: defaultAccesAllowedRoles
    },
    children: [
      {
        path: 'mizona',
        name: 'miZona',
        component: () => import('../components/AreaPersonal/MiZona/MiZona.vue'),
        meta: {
          accessAllowedGroups: ERP_GROUPS,
          accessAllowedRoles: defaultAccesAllowedRoles
        }
      },
      {
        path: 'calendario',
        name: 'calendario',
        component: () => import('../components/AreaPersonal/Calendario/Calendario.vue'),
        meta: {
          accessAllowedGroups: ERP_GROUPS,
          accessAllowedRoles: defaultAccesAllowedRoles
        }
      },
      {
        path: 'calculadora',
        name: 'calculadora',
        component: () => import('../components/AreaPersonal/Calculadora/Calculadora.vue'),
        meta: {
          accessAllowedGroups: ERP_GROUPS,
          accessAllowedRoles: defaultAccesAllowedRoles
        }
      },
      {
        path: 'liquidacion',
        name: 'liquidacion',
        component: () => import('../components/AreaPersonal/Liquidacion/Liquidacion.vue'),
        meta: {
          accessAllowedGroups: [GROUPS.MASMOVIL],
          accessAllowedRoles: [
            'SuperAdmin',
            'Admin',
          ]
        }
      },
      {
        path: 'listaupfronts',
        name: 'listaUpfronts',
        component: () => import('../components/AreaPersonal/TablaUpfront/TablaUpfront.vue'),
        meta: {
          accessAllowedGroups: [GROUPS.MASMOVIL],
          accessAllowedRoles: [
            'SuperAdmin',
            'Admin',
          ]
        }
      },
    ]
  },
  {
    path: '/fichaje',
    name: 'fichaje',
    component: () => import(/* webpackChunkName: "fichaje" */
      '../components/PunchIn/PunchInBase.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [GROUPS.PUNCH_IN],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/vacaciones',
    name: 'vacaciones',
    component: () => import(/* webpackChunkName: "vacaciones" */
      '../components/RRHH/Holidays/HolidaysBase.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/documentos',
    name: 'documentos',
    component: () => import(/* webpackChunkName: "storage" */
      '../components/Storage/StorageBase.vue'),
      props: true,
      meta: {
        accessAllowedGroups: [GROUPS.STORAGE],
        accessAllowedRoles: defaultAccesAllowedRoles
      }
  },
  {
    path: '/tutorials',
    name: 'tutorials',

    component: () => import(/* webpackChunkName: "devicemanagement" */
      '../components/Tutorials/Tutorials.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [GROUPS.MASMOVIL],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance,
    props: true,
    meta: {
      accessAllowedGroups: [],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/tiendas',
    name: 'tiendas',
    component: () => import(/* webpackChunkName: "tiendas" */
      '../components/GerenciaTeletrabajo/ShopAdministration/ShopAdministrationBase.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [GROUPS.MASMOVIL],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  },
  {
    path: '/databaseManagement',
    name: 'databaseManagement',
    component: () => import(/* webpackChunkName: "databaseManagement" */
      '../components/DatabaseManagement/DatabaseManagementBase.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [],
      accessAllowedRoles: [
        'SuperAdmin',
      ]
    }
  },
  {
    path: '/lowi',
    name: 'lowi',
    component: () => import(/* webpackChunkName: "checkLowi" */
      '../components/Lowi/LowiBase.vue'),
    props: true,
    meta: {
      accessAllowedGroups: [GROUPS.LOWI],
      accessAllowedRoles: defaultAccesAllowedRoles
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
